import { BadgeCheck, HeartPulse, FileSignature, Clock } from "lucide-react";
import { Reveal, SectionLabel } from "./shared";

const CARDS = [
  {
    icon: BadgeCheck,
    title: "ID & Health Verification",
    items: [
      {
        h: "Age Verification",
        b: "Must be 18 years of age or older. A valid government-issued photo ID is required to meet mandatory platform compliance.",
      },
      {
        h: "Health & Safety",
        b: "Must provide recent, valid STI screening results (or be willing to undergo routine screening before production dates).",
      },
    ],
    extra: HeartPulse,
  },
  {
    icon: FileSignature,
    title: "Media Releases",
    items: [
      {
        h: "Legal Documentation",
        b: "Must be willing to sign a standard Media Release and Performance Consent Agreement prior to any filming.",
      },
    ],
  },
  {
    icon: Clock,
    title: "Reliability",
    items: [
      {
        h: "Professionalism",
        b: "You must be punctual, reliable, and comfortable collaborating in a fast-paced digital media environment.",
      },
    ],
  },
];

const Requirements = () => (
  <section
    id="requirements"
    data-testid="requirements-section"
    className="relative bg-[#121212] py-24 lg:py-32"
  >
    <div className="max-w-7xl mx-auto px-6 lg:px-8">
      <SectionLabel number="02" title="What We Ask" />
      <Reveal>
        <h2 className="font-display text-white font-extrabold tracking-tighter uppercase text-4xl sm:text-5xl leading-none mb-14 max-w-2xl">
          Performer &amp; Model Requirements
        </h2>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
        {CARDS.map((card, i) => (
          <Reveal key={i} delay={i * 0.1}>
            <div
              data-testid={`requirement-card-${i + 1}`}
              className="h-full bg-[#0a0a0a] border border-[#222] p-8 lg:p-10 transition-colors duration-300 hover:border-[#d4af37] group"
            >
              <div className="flex items-center justify-between mb-8">
                <card.icon className="h-8 w-8 text-[#d4af37]" strokeWidth={1.4} />
                <span className="font-display text-white/10 text-4xl font-extrabold tabular-nums">
                  0{i + 1}
                </span>
              </div>
              <h3 className="font-display text-white text-xl font-bold tracking-tight uppercase mb-6">
                {card.title}
              </h3>
              <div className="space-y-5">
                {card.items.map((it, j) => (
                  <div key={j}>
                    <p className="text-[#d4af37] text-xs tracking-[0.15em] uppercase mb-1.5">
                      {it.h}
                    </p>
                    <p className="text-[#cccccc] text-sm leading-relaxed">
                      {it.b}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Requirements;
